import { ImportJob } from "../models/import";
import { ProjectId } from "../types";
import { Endpoints } from "./constants";
import { AssetsHttpClient } from "./createAssetsHttpClient";

export const getProjectSettingsImportClient = (
  http: AssetsHttpClient,
  projectId: ProjectId
) => {
  const base = http.getAssetsServiceBasePath(projectId);

  return {
    get: (jobId: ImportJob["id"]): Promise<ImportJob> =>
      http.get<ImportJob>(`${base}/${Endpoints.ProjectImports}/${jobId}`),

    create: (): Promise<ImportJob> =>
      http.post<ImportJob>(`${base}/${Endpoints.ProjectImports}`, {
        body: JSON.stringify({
          options: { createProgressTrackingChannel: true },
          includedModules: ["categories", "status_sets", "custom_attributes"],
        }),
      }),

    // Deliberately no `upload` method here — the project-settings-import
    // upload targets a self-signed OSS URL and must NOT go through this
    // authenticated http client (an Authorization/region header would
    // invalidate the signature). It stays a raw, adapter-only `fetch` call
    // in `getProjectSettingsImportAPIClient` (apps/acs-assets).

    complete: (jobId: ImportJob["id"]): Promise<ImportJob> =>
      http.put<ImportJob>(
        `${base}/${Endpoints.ProjectImports}/${jobId}/status/uploaded`
      ),
  };
};

/**
 * The shape returned by {@link getProjectSettingsImportClient}.
 * Exported so consumers can type variables without spelling out
 * `ReturnType<typeof getProjectSettingsImportClient>`.
 */
export type ProjectSettingsImportClient = ReturnType<
  typeof getProjectSettingsImportClient
>;
